'use strict';
const Moment = require('moment');
const _ = {
    keys: require('lodash/keys'),
}
const Strings = require('../shared/Strings');
const StringUtil = require('../shared/StringUtil');

const GraphUtil = {
        buildTimePlayedGraphData: function(timeArray) {
        const FIVE_MINUTES = 300000;
        const TEN_MINUTES = 600000;
        const FIFTEEN_MINUTES = 900000;

        let zero_five_minutes = 0;
        let five_ten_minutes = 0;
        let ten_fifteen_minutes = 0;
        let gt_fifteen_minutes = 0;

        timeArray.forEach(function(timePlayed) {
            if (timePlayed <= FIVE_MINUTES) {
                zero_five_minutes = zero_five_minutes + 1
            }
            else if (timePlayed > FIVE_MINUTES && timePlayed <= TEN_MINUTES) {
                five_ten_minutes = five_ten_minutes + 1
            }
            else if (timePlayed > TEN_MINUTES && timePlayed <= FIFTEEN_MINUTES) {
                ten_fifteen_minutes = ten_fifteen_minutes + 1
            }
            else if (timePlayed > FIFTEEN_MINUTES) {
                gt_fifteen_minutes = gt_fifteen_minutes + 1
            }
        })

        return [['< 5 min.', zero_five_minutes],
            ['5 - 10 min.', five_ten_minutes],
            ['10 - 15 min.', ten_fifteen_minutes],
            ['> 15 min.', gt_fifteen_minutes]];
    },

    buildTimePlayedGraphDataV2: (analyticsArr) => {
        return analyticsArr.map((timePlayedRange) => {
            return [
                StringUtil.getStringForTimePlayedRange(timePlayedRange.token),
                timePlayedRange.count
            ];
        })

    },

    buildScoreCategoryGraphData: (scoreCategories) => {
        let hasUnweightedCategory = false;
        const cols = [];
        scoreCategories.forEach((scoreCategory) => {
            if (scoreCategory.not_included_in_scoring) return;

            const parsedWeight = parseInt(scoreCategory.weight, 10);
            if (isNaN(parsedWeight, 10)) {
                hasUnweightedCategory = true;
                return;
            }

            cols.push([
                scoreCategory.display_name,
                parsedWeight
            ]);
        });

        if (hasUnweightedCategory) return [];

        return cols;
    },

    // generate array in format: ['columnName', 'startDate', 'startDate+1day', ..., 'endDate']
    // where dates fit format: 'YYYY-MM-DD'
    // expects startDate/endDate to be valid dates AND startDate <= endDate
    generateTimeseriesColumn: function(startDate, endDate, columnName) {
        columnName = columnName || 'x';
        let column = [columnName];

        let mCurDate = Moment(startDate);
        const mEndDate = Moment(endDate);

        while(mCurDate <= mEndDate) {
            column.push(mCurDate.format("YYYY-MM-DD"));
            mCurDate.add(1, 'd');
        }

        return column;
    },

    // generate array in format: ['columnName', 'startDate', 'startDate+1month', ..., 'endDate']
    // where dates fit format: 'YYYY-MM-DD'
    // expects startDate/endDate to be valid dates AND startDate <= endDate
    generateTimeseriesMonthlyColumn: function(startDate, endDate, columnName) {
        columnName = columnName || 'x';
        let column = [columnName];

        let mCurDate = Moment(startDate).date(1);
        const mEndDate = Moment(endDate).date(1);

        while(mCurDate <= mEndDate) {
            column.push(mCurDate.format("YYYY-MM-DD"));
            mCurDate.add(1, 'M');
        }

        return column;
    },

    // generate array in format: ['columnName', 0, 0, ..., 0] with zeros of count startDate -> endDate inclusive
    // expects startDate/endDate to be valid dates AND startDate <= endDate
    generateTimeseriesDataColumn: function(startDate, endDate, columnName) {
        columnName = columnName || 'Column';
        let column = [columnName];

        let mCurDate = Moment(startDate);
        const mEndDate = Moment(endDate);

        while(mCurDate <= mEndDate) {
            column.push(0);
            mCurDate.add(1, 'd');
        }

        return column;
    },

    buildScoreGraphData: function(scoreArray) {
        const _10 = 10;
        const _20 = 20;
        const _30 = 30;
        const _40 = 40;
        const _50 = 50;
        const _60 = 60;
        const _70 = 70;
        const _80 = 80;
        const _90 = 90;
        const _100 = 100;

        let score_0_10 = 0;
        let score_11_20 = 0;
        let score_21_30 = 0;
        let score_31_20 = 0;
        let score_41_30 = 0;
        let score_51_60 = 0;
        let score_61_70 = 0;
        let score_71_80 = 0;
        let score_81_90 = 0;
        let score_91_100 = 0;

        // TODO/FIXME
        // each category here should probably inclusive of the lower bound
        // and exclusive of the higher bound (except 100)
        scoreArray.forEach(function(score) {
            if (score <= _10) {
                score_0_10 += 1;
            }
            else if (score > _10 && score <= _20) {
                score_11_20 += 1;
            }
            else if (score > _20 && score <= _30) {
                score_21_30 += 1;
            }
            else if (score > _30 && score <= _40) {
                score_31_20 += 1;
            }
            else if (score > _40 && score <= _50) {
                score_41_30 += 1;
            }
            else if (score > _50 && score <= _60) {
                score_51_60 += 1;
            }
            else if (score > _60 && score <= _70) {
                score_61_70 += 1;
            }
            else if (score > _70 && score <= _80) {
                score_71_80 += 1;
            }
            else if (score > _80 && score <= _90) {
                score_81_90 += 1;
            }
            else if (score > _90 && score <= _100) {
                score_91_100 += 1;
            }
        });

        return [
            ['0 - 10,', score_0_10],
            ['11 - 20 ', score_11_20],
            ['21 - 30 ', score_21_30],
            ['31 - 40 ', score_31_20],
            ['41 - 50 ', score_41_30],
            ['51 - 60 ', score_51_60],
            ['61 - 70 ', score_61_70],
            ['71 - 80 ', score_71_80],
            ['81 - 90 ', score_81_90],
            ['91 - 100 ', score_91_100]
        ];
    },

    buildScoreGraphDataV2: (analyticsArr) => {
        return analyticsArr.map((scoreRange) => {
            return [
                StringUtil.getStringForScoreRange(scoreRange.token),
                scoreRange.count
            ];
        });
    },

    buildCompletedAttemptsDistGraphData: (analyticsArr, totalUsers=0, locale="en") => {
        let trackedUsers = 0;
        const cols = analyticsArr.map((numCompletedCountObj) => {
            let attLabel;
            trackedUsers += numCompletedCountObj.count;
            if (numCompletedCountObj.completed_count === 1) {
                attLabel = `${numCompletedCountObj.completed_count} ${Strings[locale].attempt.ATTEMPT}`;
            }
            else {
                attLabel = `${numCompletedCountObj.completed_count} ${Strings[locale].attempt.ATTEMPTS}`;
            }

            return [
                attLabel,
                numCompletedCountObj.count
            ];
        });

        cols.unshift([
            `0 ${Strings[locale].attempt.ATTEMPTS}`,
            totalUsers - trackedUsers,
        ]);

        return cols;
    },

    buildCompletionGraphData: function(numComplete, numTotal) {
        const parsedNumComplete = parseInt(numComplete, 10);
        return [['Complete', parsedNumComplete], ['Not Complete', parseInt(numTotal, 10) - parsedNumComplete]];
    },

    buildStartedGraphData: function(numStarted, numTotal) {
        const parsedNumStarted = parseInt(numStarted, 10);
        return [['Started', parsedNumStarted], ['Not Started', parseInt(numTotal, 10) - parsedNumStarted]];
    },

/*  buildC3Columns - data 'columnizer' for c3 charts (c3js.org)
    converts (and assumes) this format:
    dataObj = {
        key1: [1, 2, 3],
        key2: [4, 5, 6]
    };
    to:
    [
        ['key1', 1, 2, 3],
        ['key2', 4, 5, 6]
    ]
*/
    buildC3Columns: function(dataObj) {
        let retArr = [];

        _.keys(dataObj).forEach(function(key) {
            // TODO: use ES6 array spread operator once server is on node 6.x
            retArr.push([key].concat(dataObj[key]));
        });

        return retArr;
    },

/*  buildC3ColumnsSingle - data 'columnizer' for c3 charts (c3js.org)
    converts (and assumes) this format:
    dataObj = {
        key1: 25,
        key2: 50
    };
    to:
    [
        ['key1', 25],
        ['key2', 50]
    ]
*/
    buildC3ColumnsSingle: function(dataObj) {
        let retArr = [];

        _.keys(dataObj).forEach(function(key) {
            let arr = [key.toString()];
            arr.push(dataObj[key]); // TODO: use ES6 array spread operator once server is on node 6.x

            retArr.push(arr);
        });

        return retArr;
    }
}

module.exports = GraphUtil;